import { inject, Injectable } from '@angular/core';

import { TypedDialogService } from '@libs/src/typed-dialog/typed-dialog.service';

import { AIAnnouncementModalComponent } from './ai-announcement-modal.component';

@Injectable()
export class AIAnnouncementModalService {
  modalService = inject(TypedDialogService);

  openDialog({ hasAccess }: { hasAccess: boolean }) {
    return this.modalService.open(AIAnnouncementModalComponent, {
      data: { hasAccess },
      disableClose: true,
      maxWidth: '760px',
      width: '95vw',
    });
  }
}
